import { useEffect } from 'react';

/** The name of the app, at the end of every page title. */
export const NOM_APPLICATION = 'Rosetta';

/**
 * Puts the title of the page in the tab (RGAA 8.5 and 8.6, WCAG 2.4.2): "<what the page is> -
 * Rosetta", the page first because it is what a screen reader reads when the page opens and
 * what the user sees first in a narrow tab. The app is a single page that changes route without
 * a load, so each screen says its own title when it shows.
 */
export function useTitrePage(titre: string): void {
  useEffect(() => {
    document.title = `${titre} - ${NOM_APPLICATION}`;
  }, [titre]);
}
